/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/cast.json`.

import type { OperatorDefinition } from '../../definition_types';

/**
 * The `::` operator provides a convenient alternative syntax to the TO_<type> conversion functions.
 *
 * @example
 * ROW ver = CONCAT(("0"::INT + 1)::STRING, ".2.3")::VERSION
 */
const definition: OperatorDefinition = {
  operator: '::',
  name: 'cast',
  signatures: [],
  preview: false,
  snapshotOnly: false,
};

export default definition;
